// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D4EVyya_U2azycnp_8Qk {
  display: flex;
  justify-content: center;
  align-self: stretch;
  padding: 7.2px;
  gap: 8px;
  width: 100%;
  flex-wrap: wrap;
}
@media (min-width: 650px) {
  .D4EVyya_U2azycnp_8Qk {
    flex-wrap: nowrap;
    /* single row */
  }
}
.mS4iRfNPPkISt7zAd1It {
  flex-direction: column;
  padding-top: 2px;
  border-radius: 10px;
  background: var(--dark-grey);
  color: var(--settings-icon-color);
  cursor: pointer;
  display: flex;
  align-items: center;
  max-height: 81px;
  justify-content: center;
  width: calc((100% - 16px) / 3);
  aspect-ratio: 1 / 1;
  position: relative;
  /* needed for centered underline pseudo-element */
  overflow: hidden;
  /* sprite-rendered lobby icon keeps the <img> layout (no icon margin) */
}
.mS4iRfNPPkISt7zAd1It[data-type="exit"] > svg {
  margin-left: 10px;
}
.mS4iRfNPPkISt7zAd1It img,
.mS4iRfNPPkISt7zAd1It svg[data-sprite] {
  width: 43px;
  height: 51px;
}
.mS4iRfNPPkISt7zAd1It svg {
  margin-bottom: 1px;
}
.mS4iRfNPPkISt7zAd1It svg[data-sprite] {
  margin-bottom: 0;
}
@media (min-width: 460px) and (max-height: 376px) {
  .mS4iRfNPPkISt7zAd1It {
    max-height: 70px;
  }
  .mS4iRfNPPkISt7zAd1It .SMduNqSgJRSWVSPnjW8j {
    font-size: 13px;
  }
}
.SMduNqSgJRSWVSPnjW8j {
  font-size: 14.4px;
}
.sHf49Zs4wvVTs68wbYWv {
  border-bottom: none;
  /* use pseudo-element underline instead */
}
/* centered underline that doesn't reach rounded corners */
.sHf49Zs4wvVTs68wbYWv::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  /* inside the element; if clipped, try bottom: -1px */
  transform: translateX(-50%);
  width: 95%;
  /* adjust as needed (e.g., 40%–70%) */
  height: 2px;
  background: var(--piliot-green, #3CFF00);
}
.sHf49Zs4wvVTs68wbYWv svg,
.sHf49Zs4wvVTs68wbYWv div {
  color: var(--piliot-green, #3CFF00);
}
/* one-shot green flash for the deposit button (it never stays selected) */
.brGpUHuSqsPH69Bn8Sxj {
  animation: eUrLJ9Wvh5wj0z6KZMHn 500ms ease-out;
}
@keyframes eUrLJ9Wvh5wj0z6KZMHn {
  0% {
    color: var(--piliot-green, #3CFF00);
  }
  100% {
    color: var(--settings-icon-color);
  }
}
.iZzlqmW4J54CQHkFQKiA {
  background: #141414;
  color: #3f3f3f;
  cursor: not-allowed;
  pointer-events: none;
}
.iZzlqmW4J54CQHkFQKiA svg > path:last-child {
  fill: #141414;
}
`, "",{"version":3,"sources":["webpack://./src/features/settings/components/SettingsModalFooter/SettingsModalFooter.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;AACA;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;EAChB,uEAAuE;AACzE;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;AACA,0DAA0D;AAC1D;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,qDAAqD;EACrD,2BAA2B;EAC3B,UAAU;EACV,qCAAqC;EACrC,WAAW;EACX,wCAAwC;AAC1C;AACA;;EAEE,mCAAmC;AACrC;AACA,0EAA0E;AAC1E;EACE,8CAAsC;AACxC;AACA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,iCAAiC;EACnC;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;AACf","sourcesContent":[".grid {\n  display: flex;\n  justify-content: center;\n  align-self: stretch;\n  padding: 7.2px;\n  gap: 8px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n@media (min-width: 650px) {\n  .grid {\n    flex-wrap: nowrap;\n    /* single row */\n  }\n}\n.button {\n  flex-direction: column;\n  padding-top: 2px;\n  border-radius: 10px;\n  background: var(--dark-grey);\n  color: var(--settings-icon-color);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  max-height: 81px;\n  justify-content: center;\n  width: calc((100% - 16px) / 3);\n  aspect-ratio: 1 / 1;\n  position: relative;\n  /* needed for centered underline pseudo-element */\n  overflow: hidden;\n  /* sprite-rendered lobby icon keeps the <img> layout (no icon margin) */\n}\n.button[data-type=\"exit\"] > svg {\n  margin-left: 10px;\n}\n.button img,\n.button svg[data-sprite] {\n  width: 43px;\n  height: 51px;\n}\n.button svg {\n  margin-bottom: 1px;\n}\n.button svg[data-sprite] {\n  margin-bottom: 0;\n}\n@media (min-width: 460px) and (max-height: 376px) {\n  .button {\n    max-height: 70px;\n  }\n  .button .text {\n    font-size: 13px;\n  }\n}\n.text {\n  font-size: 14.4px;\n}\n.selected {\n  border-bottom: none;\n  /* use pseudo-element underline instead */\n}\n/* centered underline that doesn't reach rounded corners */\n.selected::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  /* inside the element; if clipped, try bottom: -1px */\n  transform: translateX(-50%);\n  width: 95%;\n  /* adjust as needed (e.g., 40%–70%) */\n  height: 2px;\n  background: var(--piliot-green, #3CFF00);\n}\n.selected svg,\n.selected div {\n  color: var(--piliot-green, #3CFF00);\n}\n/* one-shot green flash for the deposit button (it never stays selected) */\n.flash {\n  animation: depositFlash 500ms ease-out;\n}\n@keyframes depositFlash {\n  0% {\n    color: var(--piliot-green, #3CFF00);\n  }\n  100% {\n    color: var(--settings-icon-color);\n  }\n}\n.disabled {\n  background: #141414;\n  color: #3f3f3f;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.disabled svg > path:last-child {\n  fill: #141414;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `D4EVyya_U2azycnp_8Qk`,
	"button": `mS4iRfNPPkISt7zAd1It`,
	"text": `SMduNqSgJRSWVSPnjW8j`,
	"selected": `sHf49Zs4wvVTs68wbYWv`,
	"flash": `brGpUHuSqsPH69Bn8Sxj`,
	"depositFlash": `eUrLJ9Wvh5wj0z6KZMHn`,
	"disabled": `iZzlqmW4J54CQHkFQKiA`
};
export default ___CSS_LOADER_EXPORT___;
